@if (!isAvslutaView) {
  <div class="row">
    <rask-cards class="col-12">
      @for (atgard of arbetsorder.atgarder; track $index) {
        <rask-card
          label="{{atgard.namn}} {{atgard.beteckning}}"
          [size]="4"
          [ngClass]="{'hovering': atgard.isHovering, 'nothovering': !atgard.isHovering}"
          (mouseover)="hoverToggle(atgard, true)"
          (mouseleave)="hoverToggle(atgard, false)">
          <ng-container>
            <div class="row justify-content-between px-3">
              <rask-input class="col-4" label="Volym" value="{{atgard.volymAtgard}}"
              [readonly]="true"></rask-input>
              <rask-input class="col-4" label="Typ" value="{{atgard.atgardstyp}}"
              [readonly]="true"></rask-input>
              @if (!isLeveransvirke && !isGrot) {
                <rask-button class="col-4 align-self-end" color="tertiary"
                  (click)="removeAtgard(atgard)" [disabled]="!canRemoveAtgard" negative>Flytta till ny
                ao</rask-button>
              }
            </div>
            @if (atgard.grotuttagProduktionsplanerat) {
              <div class="row justify-content-between px-3">
                <rask-input class="col-4" label="Grot föreslagen"
                  value="{{atgard.grotuttagProduktionsplanerat ? 'Ja' : 'Nej'}}"
                [readonly]="true"></rask-input>
                @if (atgard.grotuttagProduktionsplanerat) {
                  <rask-input class="col-4" label="Grotanpassad" value="{{atgard.grotAnpassad ? 'Ja' : 'Nej'}}"
                  [readonly]="true"></rask-input>
                }
                @if (atgard.grotuttagProduktionsplanerat) {
                  <rask-input class="col-4" label="Grotvolym" value="{{atgard.grotVolym}}"
                  [readonly]="true"></rask-input>
                }
              </div>
            }
          </ng-container>
        </rask-card>
      }
    </rask-cards>
  </div>
}
@if (isAvslutaView) {
  <div class="row">
    <form [formGroup]="form" class="col-12">
      <rask-arbetsorder-atgard-produktion-avslutad
        [arbetsorder]="arbetsorder"
      [rootForm]="form"></rask-arbetsorder-atgard-produktion-avslutad>
    </form>
  </div>
}
<div class="row">
  <rask-input class="col-2" label="Total volym" value="{{sumAtgard}}" [readonly]="true"></rask-input>
  <div class="col">
    @if (arbetsorder.tidpunkter.slutrapporteradDatum) {
      <rask-textmultiline label="Digital Slutrapport">
        @if(arbetsorder?.hasActiveSlutrapport) {
          <a style="text-decoration: underline" [ngClass]="{'dsr-link': !arbetsorder.tidpunkter.slutrapporteradDatum}"
            [href]="slutrapportUrl$ | async" target="_blank">
            Länk till digital slutrapport (ny flik)
            <i class="fa-regular fa-up-right-from-square"></i>
          </a>
        } @else {
          <a class="dsr-link-inactive" [ngClass]="{'dsr-link': !arbetsorder.tidpunkter.slutrapporteradDatum}">
            Länk till digital slutrapport (inaktiv)
          </a>
        }
      </rask-textmultiline>
    }
  </div>
</div>
<div class="row">
  @if (arbetsorder.tidpunkter.produktionGodkandDatum) {
    <rask-input class="col-5" label="Arbetsorder avslutad"
    value="{{arbetsorderAvslutad}}" [readonly]="true"></rask-input>
  }
</div>
<div class="row mt-4 mb-3">
  @if (grotvolymMessage?.length) {
    <div class="col-12">
      <div class="grotvolym-message-container">
        <rask-message-panel
          [items]="grotvolymMessage">
        </rask-message-panel>
      </div>
    </div>
  }
  <div class="col-12">
    @if (isAvslutaView) {
      <rask-button id="avslutabtn" color="secondary" (click)="avslutaArbetsorder()"
      [disabled]="!canAvslutaArbetsorder">Avsluta arbetsorder</rask-button>
    }
    <rask-button [ngClass]="{'stinabtn-no-avslutabtn': !isAvslutaView}" class="stinabtn-no-avslutabtn" id="stinabtn"
      color="secondary" (click)="fetchGrotvolymFromStina()" [disabled]="!canFetchGrotvolymFromStina"
    ngbTooltip="Hämta grotvolym från Stina" [openDelay]="300">Hämta grotvolym</rask-button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    @if (arbetsorderHasUtbytesberakning) {
      <span>Det finns ändrade utbytesberäkningssiffror för den här
      arbetsordern.</span>
    }
  </div>
</div>